import {Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {ArchitectureStructureSettingModel} from '../../../models/ArchitectureStructureSettingModel';
import {ArchitectureStructureService} from './service/architecture-structure.service';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import * as toastr from 'toastr';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import { Router } from '@angular/router';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import {UsersService} from '../../users/service/users.service';
import {ProviderModel} from "../../../models/ProviderModel";

@Component({
  selector: 'app-architecture-structure',
  templateUrl: './architecture-structure.component.html',
  styleUrls: ['./architecture-structure.component.scss']
})
export class ArchitectureStructureComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isArchitectureStructureSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  defaultProviderSelected: ProviderModel;

  offset: Offset;
  filter: ArchitectureStructureSettingModel;
  providerData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private architectureStructureService: ArchitectureStructureService,
              private providerService: ProviderAnagrafService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.SETTINGS;
    this.filter = new ArchitectureStructureSettingModel();
  }

  ngOnInit() {
    this.isArchitectureStructureSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    this.defaultProviderSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));

    if (this.defaultProviderSelected.description === this.PROVIDER_DXC) {
      this.displayedColumns = ['provider', 'resourceUnitCod', 'resourceUnitName', 'designServicesDesc',
        'layerDesc', 'l1Desc', 'l2Desc', 'l3Desc', 'Size', 'Site', 'unitsDesc', 'actions'];
    } else {
      this.displayedColumns = ['provider', 'resourceUnitCod', 'resourceUnitName', 'designServicesDesc',
        'layerDesc', 'l1Desc', 'l2Desc', 'l3Desc', 'unitsDesc', 'actions'];
    }

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.ARCHITECTURE_STRUCTURE_SETTING_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  init() {

    const getFirstProviderObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filter).pipe();

    getFirstProviderObservable.subscribe(
      (result: any) => {
        this.providerData = result;

        if (!this.filter.provider) {
          this.filter.provider = result ? result[0] : null;
        }

        this.getDataPage(this.offset, this.filter);
      }, error => {
        console.log(error);
      }
    );
  }

  getDataPage(offset: Offset, filter: ArchitectureStructureSettingModel) {
    this.getAllSubscribe = this.architectureStructureService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: any) {
    if (this.defaultProviderSelected.description === this.PROVIDER_DXC) {
      const architectureData = this.dataSource.find(data => data.id === id) as ArchitectureStructureSettingModel;
      const list: GenericArray[] = [
        {id: 'Provider Cod', value: this.toCustomString(architectureData.provider.cod)},
        {id: 'Provider Desc', value: this.toCustomString(architectureData.provider.description)},
        {id: 'Resource Unit Cod', value: this.toCustomString(architectureData.resourceUnit.cod)},
        {id: 'Resource unit Name', value: this.toCustomString(architectureData.resourceUnit.name)},
        {id: 'SL1 Cod', value: this.toCustomString(architectureData.designServices.cod)},
        {id: 'SL1 Description', value: this.toCustomString(architectureData.designServices.description)},
        {id: 'SL2 Cod', value: architectureData.layer ? architectureData.layer.cod : 'N.D.'},
        {id: 'SL2 Description', value: architectureData.layer ? architectureData.layer.description : 'N.D.'},
        {id: 'SL3 Cod', value: architectureData.l1 ? architectureData.l1.cod : 'N.D.'},
        {id: 'SL3 Description', value: architectureData.l1 ? architectureData.l1.description : 'N.D.'},
        {id: 'SL4 Cod', value: architectureData.l2 ? architectureData.l2.cod : 'N.D.'},
        {id: 'SL4 Description', value: architectureData.l2 ? architectureData.l2.description : 'N.D.'},
        {id: 'SL5 Cod', value: architectureData.l3 ? architectureData.l3.cod : 'N.D.'},
        {id: 'SL5 Description', value: architectureData.l3 ? architectureData.l3.description : 'N.D.'},
        {id: 'Size Cod', value: architectureData.size ? architectureData.size.cod : 'N.D.'},
        {id: 'Size Description', value: architectureData.size ? architectureData.size.description : 'N.D.'},
        {id: 'Site Cod', value: architectureData.site ? architectureData.site.cod : 'N.D.'},
        {id: 'Site Description', value: architectureData.site ? architectureData.site.description : 'N.D.'},
        {id: 'Units Cod', value: architectureData.units ? architectureData.units.cod : 'N.D.'},
        {id: 'Units Description', value: architectureData.units ? architectureData.units.description : 'N.D.'},
      ];
      const dialogRef = this.dialog.open(DialogDetailComponent, {
        data: {list}
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('The dialog was closed');
      });
    } else{      const architectureData = this.dataSource.find(data => data.id === id) as ArchitectureStructureSettingModel;
      const list: GenericArray[] = [
        {id: 'Provider Cod', value: this.toCustomString(architectureData.provider.cod)},
        {id: 'Provider Desc', value: this.toCustomString(architectureData.provider.description)},
        {id: 'Resource Unit Cod', value: this.toCustomString(architectureData.resourceUnit.cod)},
        {id: 'Resource unit Name', value: this.toCustomString(architectureData.resourceUnit.name)},
        {id: 'SL1 Cod', value: this.toCustomString(architectureData.designServices.cod)},
        {id: 'SL1 Description', value: this.toCustomString(architectureData.designServices.description)},
        {id: 'SL2 Cod', value: architectureData.layer ? architectureData.layer.cod : 'N.D.'},
        {id: 'SL2 Description', value: architectureData.layer ? architectureData.layer.description : 'N.D.'},
        {id: 'SL3 Cod', value: architectureData.l1 ? architectureData.l1.cod : 'N.D.'},
        {id: 'SL3 Description', value: architectureData.l1 ? architectureData.l1.description : 'N.D.'},
        {id: 'SL4 Cod', value: architectureData.l2 ? architectureData.l2.cod : 'N.D.'},
        {id: 'SL4 Description', value: architectureData.l2 ? architectureData.l2.description : 'N.D.'},
        {id: 'SL5 Cod', value: architectureData.l3 ? architectureData.l3.cod : 'N.D.'},
        {id: 'SL5 Description', value: architectureData.l3 ? architectureData.l3.description : 'N.D.'},
        {id: 'Units Cod', value: architectureData.units ? architectureData.units.cod : 'N.D.'},
        {id: 'Units Description', value: architectureData.units ? architectureData.units.description : 'N.D.'},
      ];
      const dialogRef = this.dialog.open(DialogDetailComponent, {
        data: {list}
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('The dialog was closed');
      });
    }
  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.ARCHITECTURE_STRUCTURE_SETTING_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.loaderService.display(true);
      this.deleteElementSubscribe = this.architectureStructureService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Architecture Structure with id ' + id + ' was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              toastr.info('Architecture Structure cannot be deleted', 'Alert');
            }
            this.loaderService.display(false);
          }, error =>  {
            toastr.error('Resource unit with id ' + id + ' was not deleted', 'Error');
            this.loaderService.display(false);
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    this.getDataPage(this.offset, this.filter);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {

    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.ARCHITECTURE_STRUCTURE_SETTING_FILTER));
    this.filter = filter_ ? filter_ : new ArchitectureStructureSettingModel();
    this.getDataPage(this.offset, this.filter);
  }

}
